import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    error: null,
};

export const pageErrorSlice = createSlice({
    name: 'pageError',
    initialState,
    reducers: {
        addPageError: (state, action) => ({
            ...state,
            error: action.payload,
        }),
        resetPageError: (state) => ({
            ...state,
            error: null,
        }),
    },
});

// Action creators are generated for each case reducer function
export const { addPageError, resetPageError } =
    pageErrorSlice.actions;

export default pageErrorSlice.reducer;
